import { OnboardingAnswerNormalized } from "../types";
import { NON_STEP_QUESTIONS } from "../constants";
import { getUniqueAnswers, ORDERED_STEPS } from "../helpers";
import { useGetIdentity, useList } from "@refinedev/core";
import { AppUser } from "types";

export default function useOnboardingAnswers() {
  const userData = useGetIdentity<AppUser>();

  const { data: answersData, isLoading: isLoadingAnswers } =
    useList<OnboardingAnswerNormalized>({
      resource: "media/onboarding/answer",
      filters: [
        {
          field: "user_id",
          operator: "eq",
          value: userData?.data?.id,
        },
      ],
      queryOptions: {
        enabled: !!userData?.data?.id,
      },
    });

  return {
    data: answersData,
    isLoading: isLoadingAnswers,
    hasCompletedOnboarding: hasCompletedOnboardingSteps(answersData?.data), // for debug: false,
    shouldGoToOnboarding: isLoadingAnswers
      ? false
      : shouldGoToOnboarding(userData?.data, answersData.data),
  };
}

function shouldGoToOnboarding(
  userData: AppUser,
  answers: OnboardingAnswerNormalized[]
) {
  // NB: This is for admins and some special users so that they can skip onboarding. It's not the actual onboarding status.
  const skipOnboarding = userData?.onboarding_status === 1;

  const hasCompletedOnboarding = hasCompletedOnboardingSteps(answers);

  return !skipOnboarding && !hasCompletedOnboarding;
}
function hasCompletedOnboardingSteps(answers: OnboardingAnswerNormalized[]) {
  return (
    // This is the real onboarding status for regular users. If they have answered all questions they will not see onboarding anymore. Right now we do not load their previous answers so they will have to start onboarding from scratch every time they go there. If they completed onboarding and they go to it directly, they will see the finish screen.
    getUniqueAnswers(answers).size >=
    Object.keys(ORDERED_STEPS).length - NON_STEP_QUESTIONS.length
  );
}
